import { render, staticRenderFns } from "./InstagramStoryErrorPlaceHolder.vue?vue&type=template&id=38c07fa8&"
import script from "./InstagramStoryErrorPlaceHolder.vue?vue&type=script&lang=js&"
export * from "./InstagramStoryErrorPlaceHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports